import * as _ from 'lodash';
import { CoughReOpenCommentGroup, CoughAnalysisSetReOpenComment } from "../../../../misc/api/apiTypes";

export function IsFreeTextAllowed(commentGroups: CoughReOpenCommentGroup[]): boolean {
    return !!_.find(commentGroups, upCg => upCg.SelectedOption === "Other") || !!_.find(commentGroups, cg => cg.GroupName === "Process" && cg.SelectedOption === "QA - Other");
};

export function GetSelectedOptions(fixedCommentGroups: CoughReOpenCommentGroup[]): CoughAnalysisSetReOpenComment[] {
    return fixedCommentGroups.map(fc => {
        return {
            GroupName: fc.GroupName,
            Comment: fc.SelectedOption
        };
    });
};

export function ValidateSubmittedComments(commentGroups: CoughReOpenCommentGroup[]): string[] {

    const errors = _.compact(_.map(commentGroups, reCG => {
        if (!reCG.SelectedOption) {
            return "Missing selection for group: " + reCG.GroupName;
        } else if (!_.find(reCG.Comments, com => com === reCG.SelectedOption)) {
            return "Invalid option selection for group: " + reCG.GroupName;
        } else {
            return null;
        }
    }));

    return errors;
}

export function ShouldDisplay(expectedDropdownType: DropdownCommentTypes) {

    return (analysisSetId: string, actualDropdownType: DropdownCommentTypes) => {
        return actualDropdownType === expectedDropdownType && !!analysisSetId;
    };
};

export enum DropdownCommentTypes {
    ReOpen = "ReOpen",
    EditReOpen = "EditReOpen",
    ReviewComplete = "ReviewComplete",
    EditReviewComplete = "EditReviewComplete",
    ResetReview = "ResetReview",
    StartNewReview = "StartNewReview"
}
